import axios from 'axios';
import API_BASE_URL from '../config';

// Configurazione axios con interceptor per token
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor per aggiungere token JWT se disponibile
api.interceptors.request.use(
  (config) => {
    const adminToken = localStorage.getItem('adminToken');
    const userToken = localStorage.getItem('token');
    const token = adminToken || userToken;
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ============ STATI BECCO ============

/**
 * Recupera lo stato corrente del Becco
 * @param {number} adminId - ID dell'admin
 */
export const getCurrentStatus = async (adminId) => {
  const response = await api.get(`/status/${adminId}`);
  return response.data;
};

/**
 * Aggiorna lo stato del Becco
 * @param {object} statusData - {adminId, status, customStatusId?, customMessage?}
 */
export const updateStatus = async (statusData) => {
  const response = await api.post('/status', statusData);
  return response.data;
};

/**
 * Recupera tutte le descrizioni degli stati standard
 * @param {number} adminId - ID dell'admin
 */
export const getStatusDescriptions = async (adminId) => {
  const response = await api.get(`/status/descriptions/${adminId}`);
  return response.data;
};

/**
 * Aggiorna la descrizione di uno stato standard
 * @param {object} descData - {adminId, statusKey, customDescription}
 */
export const updateStatusDescription = async (descData) => {
  const response = await api.put('/status/descriptions', descData);
  return response.data;
};

// ============ STATI PERSONALIZZATI ============

/**
 * Recupera tutti gli stati personalizzati del Becco
 * @param {number} adminId - ID dell'admin
 */
export const getCustomStatuses = async (adminId) => {
  const response = await api.get(`/status/custom/${adminId}`);
  return response.data;
};

/**
 * Crea un nuovo stato personalizzato
 * @param {object} customStatus - {adminId, label, emoji, message}
 */
export const createCustomStatus = async (customStatus) => {
  const response = await api.post('/status/custom', customStatus);
  return response.data;
};

/**
 * Modifica uno stato personalizzato
 * @param {number} id - ID dello stato custom
 * @param {object} updates - {adminId, label?, emoji?, message?}
 */
export const updateCustomStatus = async (id, updates) => {
  const response = await api.put(`/status/custom/${id}`, updates);
  return response.data;
};

/**
 * Elimina uno stato personalizzato
 * @param {number} id - ID dello stato custom
 * @param {number} adminId - ID dell'admin
 */
export const deleteCustomStatus = async (id, adminId) => {
  const response = await api.delete(`/status/custom/${id}`, {
    data: { adminId }
  });
  return response.data;
};

// ============ GESTIONE AMICI ============

/**
 * Recupera info sul Becco seguito dall'utente
 * @param {number} userId - ID dell'utente
 */
export const getMyBecco = async (userId) => {
  const response = await api.get(`/friends/my-becco?userId=${userId}`);
  // Ritorna direttamente i dati
  return response.data;
};

/**
 * Lista amici del Becco (solo admin)
 * @param {number} adminId - ID dell'admin
 */
export const getFriends = async (adminId) => {
  const response = await api.get(`/friends?adminId=${adminId}`);
  return response.data;
};

// ============ PROGRAMMAZIONE STATI ============

/**
 * Recupera tutti gli schedule programmati
 * @param {number} adminId - ID dell'admin
 */
export const getSchedules = async (adminId) => {
  const response = await api.get(`/status/schedule/${adminId}`);
  return response.data;
};

/**
 * Crea un nuovo schedule
 * @param {object} scheduleData - {scheduleName, status, customStatusId?, customMessage?, daysOfWeek, startTime, endTime, isActive?, restorePreviousStatus?}
 */
export const createSchedule = async (scheduleData) => {
  const response = await api.post('/status/schedule', scheduleData);
  return response.data;
};

/**
 * Aggiorna uno schedule esistente
 * @param {number} id - ID dello schedule
 * @param {object} updates - Campi da aggiornare
 */
export const updateSchedule = async (id, updates) => {
  const response = await api.put(`/status/schedule/${id}`, updates);
  return response.data;
};

/**
 * Elimina uno schedule
 * @param {number} id - ID dello schedule
 */
export const deleteSchedule = async (id) => {
  const response = await api.delete(`/status/schedule/${id}`);
  return response.data;
};

export default {
  getCurrentStatus,
  updateStatus,
  getStatusDescriptions,
  updateStatusDescription,
  getCustomStatuses,
  createCustomStatus,
  updateCustomStatus,
  deleteCustomStatus,
  getMyBecco,
  getFriends,
  getSchedules,
  createSchedule,
  updateSchedule,
  deleteSchedule
};
